"use client";
import { useEffect } from "react";
import { DeviceType } from "@/app/utils/index";
const Log = () => {
  useEffect(() => {
    import("current-device").then((module) => {
      let deviceType = module.default.type as DeviceType;
      if (deviceType === DeviceType.DESKTOP) {
        deviceType = DeviceType.PC;
      }
      if (deviceType === DeviceType.UNKNOWN) {
        deviceType = DeviceType.OTHER;
      }
      import("@ccint/log").then((Log) => {
        Log.config({
          app_id: "8VyetAGHDa7MBnRVBBSUNFn4PG97BK8y", // 复制m站的app_id
          product_name: "cs_hw_xy", // 产品名称
          app_version: "1.0.0", // 版本号
          env: "online", // 环境
        });
        window.Log = Log;
        // 写一个延时，防止pageid被覆盖
        setTimeout(() => {
          Log.page("HWOfficialPaidSchoolVersionPage", {
            user_access_port: deviceType,
          });
        }, 1000);
        Log.tracePerformance();
      });
    });
  }, []);
  return null;
};

export default Log;
